import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

const styles = () => ({
  root: {
    display: 'flex',
    alignContent: 'center',
  },
});

function ListItemContent({
  className,
  classes,
  children,
}) {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {children}
    </div>
  );
}

ListItemContent.defaultProps = {
  className: '',
};

ListItemContent.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItemContent);
